
export class SecurityQuestionModel {
  question: string;

  constructor(data = null) {
    this.question = data;
  }
}
